import { render, staticRenderFns } from "./ad_qunfeng.vue?vue&type=template&id=1a824022&scoped=true"
import script from "./ad_qunfeng.vue?vue&type=script&lang=js"
export * from "./ad_qunfeng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a824022",
  null
  
)

export default component.exports